<template>
  <div
    v-if="initialized"
    class="h-full w-full flex"
    :class="{ 'flex-col': mq.isMobile }"
  >
    <NavbarDesktopSupervisor />
    <main
      id="page"
      class="w-full h-full p-5"
    >
      <router-view />
    </main>
  </div>
</template>

<script>
import NavbarDesktopSupervisor from '@/app/_supervisors/components/navbar/TheNavbarDesktopSupervisor.vue';
import { ROUTES_SUPERVISORS } from '@/app/data/route_constants';
import profile_mixin from '@/app/util/profile_mixin';

export default {
  name: 'Supervisor',
  components: {
    NavbarDesktopSupervisor,
  },
  mixins: [profile_mixin],

  data() {
    return {
      ROUTES_SUPERVISORS,
    };
  },

  computed: {
    is_dashboard_page() {
      return this.$route.name.startsWith(ROUTES_SUPERVISORS.DASHBOARD);
    },
  },

  async created() {
    await this.initProfile();
  },
};
</script>
